// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EnvironmentTwoToneSvg from "@ant-design/icons-svg/es/asn/EnvironmentTwoTone";
import AntdIcon from '../components/AntdIcon';

var EnvironmentTwoTone = function EnvironmentTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EnvironmentTwoToneSvg
  }));
};

EnvironmentTwoTone.displayName = 'EnvironmentTwoTone';
export default React.forwardRef(EnvironmentTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/EnvironmentTwoTone.js
// module id = 1017
// module chunks = 0